import BrickTitle from "@/components/landing/BrickTitle";

export default function ServiceArea() {
  return (
    <section className="py-16 max-w-6xl mx-auto px-4 sm:px-6" data-testid="service-area-section">
      <div className="bg-white rounded-2xl border border-[#E6DCD3] p-8 sm:p-10">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-[#D4691E]">Service Area</span>
            <h2 className="text-2xl sm:text-3xl font-bold mt-1 mb-4">
              <BrickTitle text="Proudly Serving All of South Louisiana" />
            </h2>
            <p className="text-sm text-[#665E56] leading-relaxed mb-6">
              Based in South Louisiana and serving residents across the entire region — from Baton Rouge and
              Lafayette to the bayou parishes and everywhere in between. Larger fabrication, construction, and
              estate projects get the same mobile, fully-equipped service.
            </p>
            <div className="space-y-2 text-xs text-[#544D45]">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#D4691E]" />
                <span>
                  <strong>Primary Zone:</strong> All South Louisiana towns, suburbs &amp; parishes
                </span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-[#D4691E]" />
                <span>
                  <strong>Extended Zone:</strong> Statewide Louisiana for full-day &amp; multi-day project builds
                </span>
              </div>
            </div>
          </div>

          <div className="aspect-[16/10] rounded-xl overflow-hidden border border-[#3A4752] bg-gradient-to-br from-[#28323A] via-[#232A31] to-[#1A2128] relative flex items-center justify-center p-6 text-center">
            <div className="bg-white/90 backdrop-blur-sm p-4 rounded-lg border border-[#DCD3C9] max-w-xs shadow-sm">
              <span className="text-xs font-bold text-[#1E252B] block">Mobile Workshop Unit</span>
              <span className="text-[11px] text-[#736B63] block mt-1">
                Equipped with welding rig, HVAC gauges, carpentry tools &amp; diagnostic sensors
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
